var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKinesis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7998 14.1971L11.9804 18.7761L22.1604 14.1971L11.9801 13.7849L1.7998 14.1971Z",
    fill: "#FCBF92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0113 0.797852L1.80441 5.77185V12.7901H14.0436V1.79035L12.0113 0.797852Z",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80441 17.7379L12.0175 24.7979L22.1993 17.7379L11.9949 16.2869L1.80441 17.7379Z",
    fill: "#FCBF92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0113 12.7901H17.3963V5.3011L15.8238 4.6866L12.0116 5.7731L12.0113 12.7901Z",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8238 12.7901H19.9861V7.9326L18.7956 7.5836L15.8238 8.0766V12.7901Z",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7956 7.20285V12.7901H22.1601L22.1998 7.1781L21.1777 6.7791L18.7956 7.20285Z",
    fill: "#9D5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0113 0.797852V12.7901H14.0436V1.79035L12.0113 0.797852ZM17.3963 5.3011L15.8238 4.6866V12.7901H17.3963V5.3011ZM19.9861 7.9326L18.7956 7.5836L18.7956 12.7904H19.9861V7.9326ZM21.1777 12.7901H22.1995V7.17785L21.1777 6.77885V12.7901ZM11.9804 15.1919V18.7761L22.1604 16.2966V14.1971L11.9804 15.1919ZM11.9804 21.2589V24.7979L22.1993 19.8054V17.7379L11.9804 21.2589Z",
    fill: "#F68534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80441 19.8269L11.9804 24.7979V21.2329L1.80492 17.7376L1.80441 19.8269ZM1.7998 16.2966L11.9804 18.7761V15.1919L1.7998 14.1969V16.2966Z",
    fill: "#9D5025"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinesis);
export default __webpack_public_path__ + "static/media/Kinesis.a37af8c3e360c778ba7f3dc2819e71bf.svg";
export { ForwardRef as ReactComponent };